import { render, staticRenderFns } from "./SettingsLanguages.vue?vue&type=template&id=d579ccca&scoped=true"
import script from "./SettingsLanguages.vue?vue&type=script&lang=js"
export * from "./SettingsLanguages.vue?vue&type=script&lang=js"
import style0 from "./SettingsLanguages.vue?vue&type=style&index=0&id=d579ccca&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d579ccca",
  null
  
)

export default component.exports